import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import slick from 'slick-carousel';
import $ from 'jquery';

export default {
	init() {

		var container = document.querySelector('.carGallery');

		if( container ) {

			function carGalleryCarousel( container ) {

				var carousel = container.querySelector('.carGallery__big .big__slick');

				var imagesBox = container.querySelector('.carGallery__box');
				var imagesBoxWidth = imagesBox.offsetWidth;

				var imagesBoxSmallTransform;
				var imagesBoxSmall = container.querySelector('.carGallery__box .box__images');
				var imagesBoxSmallStyle = getComputedStyle(imagesBoxSmall);

				var smallImages = imagesBoxSmall.querySelectorAll('.carGallery__image');
				
				var imageStyle = getComputedStyle(smallImages[0]);
				var imageWidth = parseInt(smallImages[0].offsetWidth) + parseInt(imageStyle.marginRight);

				var userAction = false;

				// -- Include functions -- //

					function GetTransform() {

						imagesBoxSmallTransform = new WebKitCSSMatrix(imagesBoxSmallStyle.webkitTransform);

						imagesBoxSmallTransform = imagesBoxSmallTransform.m41;

						return imagesBoxSmallTransform;

					};

					var transform;
					var halfBox;

					function Transform( index ) {

						transform = ( (index+1) * imageWidth) + GetTransform();
						halfBox = imagesBoxWidth/2;

						if( index == 0 ) {

							imagesBoxSmall.style.transform = 'translateX(0px)';

						} else {

							if( transform > halfBox && (smallImages.length * imageWidth) + GetTransform() > imagesBoxWidth ) {

								imagesBoxSmall.style.transform = 'translateX(' + ( - imageWidth + GetTransform() ) + 'px)';

							} else if(transform < halfBox && GetTransform() < 0 ) {

								imagesBoxSmall.style.transform = 'translateX(' + ( imageWidth + GetTransform() ) + 'px)';

							}	

						}

					};

				// -- END -- // 


				// -- Slick -- //

					$(carousel).on('init', function() {

						smallImages[0].classList.add('actual');
						smallImages[0].classList.add('active');

					});


					$(carousel).slick({
						slidesToShow : 1,
						slidesToScroll : 1,
						arrows : false,
						// fade: true,
	  					// cssEase: 'linear',
	  					speed: 500,
	  					autoplay : true,
	  					autoplaySpeed : 3000,
					});	

					$(carousel).on('swipe', function(event, slick, direction) {
						$(carousel).slick('slickPause');
						userAction = true;
					});

					$(carousel).on('beforeChange', function(slick,currentSlide) {

						smallImages.forEach( function(image,index) {

							image.classList.remove('active');

						});	

					});


					$(carousel).on('afterChange', function(slick,currentSlide) {

						smallImages.forEach( function(image,index) {

							image.classList.remove('active');
							image.classList.remove('actual');

						});

						if( !userAction ) {
							smallImages[$(carousel).slick('slickCurrentSlide')].classList.add('active');
						}
						smallImages[$(carousel).slick('slickCurrentSlide')].classList.add('actual');

						Transform( $(carousel).slick('slickCurrentSlide') );

					});

				// -- END -- //


				// -- Own actions -- //

					smallImages.forEach( function( image,index ) {

						image.addEventListener('click', function() {

							smallImages.forEach( function(image2, index2) {
								image2.classList.remove('active');
							});
							$(carousel).slick('slickGoTo', index);
							userAction = true;

						});

						image.addEventListener('mouseenter', function() {

							smallImages.forEach( function(image2, index2) {

								image2.classList.remove('active');

							});

							$(carousel).slick('slickPause');

						});

						image.addEventListener('mouseleave', function() {
							if( !userAction ) {
								smallImages.forEach( function(image2, index2) {

									if( image2.classList.contains('actual') ) {

										image2.classList.add('active');
											
									}

								});
								$(carousel).slick('slickPlay');
							}
						});

					});

				// -- END -- //

			}

			function CarGalleryPhotoSwipe() {

				var images = document.querySelectorAll('.carGallery .carGallery__box .carGallery__image');
				var image_index = 0;
				var maximalize = document.querySelector('.carGallery__maxImage');

				// *** INIT *** //

					var pswp; // photoSwipe mask
					var items; // photoSwipe images
					var options = Array(); // photoSwipe options
					var photoSwipe; // photoSwipe object

					function Init(index) {

						items = Array();

						pswp = document.querySelectorAll('.pswp')[0];

						options.index = parseInt(index, 10);
						options.fullscreenEl = false;
						options.shareEl = false;

						var item; 
						var image;
						var image_url;
						var image_dimention;
						var image_width;
						var image_height;

						images.forEach( function( image , index2 ) {

							image_url = image.getAttribute('data-url');
							image_dimention = image.getAttribute('data-size').split('x');
							image_width = image_dimention[0];
							image_height = image_dimention[1];

							item = {

								src: image_url,
			                    w: image_width,
			                    h: image_height

							};

							items.push( item );


						});

						photoSwipe = new PhotoSwipe( pswp, PhotoSwipeUI_Default, items, options);

					}

					Init();

				// *** END INIT *** //


				// *** AUTO OPEN *** //

					function GetPicNumber() {

						var pic = window.location.hash;
						pic = pic.replace('#&','');
						pic = pic.split('&');

						pic.forEach( function( cell, index ) {

							pic[index] = cell.split('=');

						});

						pic.forEach( function( cell, index ) {

							if( cell[0] == 'swipeit_pic' ) {

								console.log(cell[1]);
								Init( cell[1] );
								photoSwipe.init();	

							}

						});

					}

					GetPicNumber();

				// *** END AUTO OPEN *** //				   



				// *** OPEN *** //

					maximalize.addEventListener('click' , function(){

						images.forEach( function( image , index ) {

							if( image.classList.contains('actual') ) {

								image_index = index;

							}  

						});
						console.log(image_index);
						Init( image_index );
						photoSwipe.init();						

					});

				// *** OPEN *** ///

			}

			carGalleryCarousel( container );

			if( container.classList.contains('photoSwipeInit') ) {

				CarGalleryPhotoSwipe();

			}

		}

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};